<div class="property-amenities">
    @for (c of categories; track c) {
        @if (amenitiesByCategory(c)?.length) {
            <div>
                <h3><span class="material-symbols-outlined">{{ getCategoryIcon(c) }}</span> {{c}}</h3>
                <div>
                @for (a of amenitiesByCategory(c); track a.id) {
                    <mat-chip>{{ a.name }}</mat-chip>
                } 
                <!-- @empty {
                    <p>No amenities in this category</p>
                } -->
                </div>
            </div>
        }
    } 
    <!-- @notEmpty {
        <p>No categories available</p>
    } -->

    <!-- <mat-chip *ngFor="let a of property.amenities; trackBy: trackByFn">
        {{ a.name }}
    </mat-chip> -->
</div>
